import React, { useState, useEffect } from 'react'
import { Text, View, StyleSheet, Font } from '@react-pdf/renderer'
import ScaleBarPulse from './ScaleBarPulse'
import TableGridPulse from './TableGridPulse'

Font.registerHyphenationCallback(word => [word]);

const styles = StyleSheet.create({
    categoryText: {
        paddingLeft: '0%',
        paddingRight: '5%',
        marginTop: 45,
    },
    tableHeader: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        paddingLeft: '5%',
        paddingRight: '5%',
        backgroundColor: 'rgb(226 232 240)',
    },
    tableHeaderTitle: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        paddingTop: 5,
        paddingBottom: 5,
    },
    tableHeaderTitleText1: {
        fontFamily: 'Inter',
        fontSize: 15,
        fontWeight: 500,
        marginRight: 5,
    },
    tableHeaderTitleText2: {
        fontFamily: 'Inter',
        fontSize: 12,
    },
    tableContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'stretch',
        borderBottom: '1 solid rgb(226 232 240)',
    },
    tableFirstCol: {
        width: '60%',
        backgroundColor: '#ffffff',
    },
    tableFirstColAnswer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '100%',
    },
    tableFirstColAnswerNumber: {
        width: '10%',
        paddingLeft: 3,
        paddingRight: 3,
        marginTop: -1,
        paddingTop: 0,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    tableFirstColAnswerText: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '80%',
        paddingRight: 10,
        paddingTop: 0,
        paddingBottom: 3,
    },
    tableFirstColAnswerPoints: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
        width: '10%',
        height: '100%',
        textAlign: 'right',
        paddingLeft: 5,
        paddingRight: 5,
    },
    tableLastCol: {
        width: '40%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: 'rgb(226 232 240)',
        borderBottom: '1 solid #fff',
        paddingRight: 7,
        opacity: 0.7,
    },
    tableLastColRows: {
        width: '100%',
        flexDirection: 'row',
        height: 15,
    },
    scaleBarContainer: {
        position: 'relative',
        zIndex: 50,
        display: 'flex',
        flexDirection: 'row',
    },
    gridContainer: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        left: '5.5%',
        top: -1,
        display: 'flex',
        flexDirection: 'row',
        borderTop: '1 solid rgb(226 232 240)',
    },
    inclImage: {
        width: '103px',
        height: '119px',
    },
    inclImageText: {
        display: 'block',
        fontFamily: 'Inter',
        fontSize: 9,
        fontWeight: 500,
        lineHeight: 1.4,
        textAlign: 'right',
    },
    inclImageText2: {
        display: 'block',
        fontFamily: 'Inter',
        fontSize: 10,
        fontWeight: 600,
        lineHeight: 1.4,
        textAlign: 'center',
        paddingTop: 10,
    }
});

const AnswersTableGuideQuinary = ({ answersData, categoriesData, matchCategory, spaceTop, spaceBottom, uiData, coverData }) => {

    const current = uiData.current;
    const currentText = `(${current})`;

    const [matchedCategory, setMatchedCategory] = useState(null);
    const [answersFromCategory, setAnswersFromCategory] = useState([]);

    const roundToTwoDecimals = (num) => { 
        if (isNaN(num) || num === null) {
            return "0.0";
        }
        const rounded = Math.round(num * 100) / 100;
        return rounded % 1 === 0 ? `${rounded}.0` : rounded.toFixed(1);
    };

    useEffect(() => {
        if (answersData && categoriesData) {
            const categoryData = categoriesData.find(item => item.name === matchCategory);
            setMatchedCategory(categoryData);

            if (matchCategory === uiData.lowest) {
                const allAnswers = [...answersData];
                const lowestPoints = allAnswers.sort((a, b) => a.points - b.points);
                const result = lowestPoints.slice(0, 10);
                setAnswersFromCategory(result);
            } else if (matchCategory === uiData.highest) {
                const allAnswers = [...answersData];
                const highestPoints = allAnswers.sort((a, b) => b.points - a.points);
                const result = highestPoints.slice(0, 10);
                setAnswersFromCategory(result);
            } else {
                const result = answersData.filter(item => item.category === matchCategory);
                setAnswersFromCategory(result);
            }
        }
    }, [answersData, categoriesData, matchCategory, uiData.lowest, uiData.highest]);

    const calculateXPositionCategory = (point) => {
        return point !== undefined ? ((point - 1) / 4) * 100 : 0;
      };


    return (
        <>

            <View style={styles.tableHeader}>
                <View style={styles.tableHeaderTitle}>
                    <Text style={styles.tableHeaderTitleText1}>{matchCategory}</Text>
                    <Text style={styles.tableHeaderTitleText2}>{currentText}</Text>
                </View>
            </View>
            <View style={{
                display: 'flex',
                flexDirection: 'column',
            }}>
                <View
                    style={{
                        position: 'relative',
                        paddingLeft: '5%',
                        paddingRight: '5%',
                        marginTop: spaceTop,
                        marginBottom: spaceBottom,
                        width: '100%',
                    }}
                >
                    <View style={styles.gridContainer} zIndex={9999}>
                        <View style={{ width: '60%' }}></View>
                        <View style={{ width: '40%' }}>
                            <TableGridPulse />
                            <View
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    bottom: 25,
                                    left: `${calculateXPositionCategory(coverData.avgPoint) - 0.5}%`,
                                    borderLeftWidth: 1,
                                    borderLeftColor: '#3395E0',
                                    borderStyle: 'dashed',
                                    zIndex: 9999,
                                }}
                            ></View>
                        </View>
                    </View>

                    {answersFromCategory.map(
                        ({ id, answer, points }, index) => {
                            const averagePoints = roundToTwoDecimals(coverData.avgPoint);
                            const roundedPoints = roundToTwoDecimals(points);
                            const xPos = ((roundedPoints - 1) / 4) * 100;

                            const getBackgroundColor = (roundedPoints, averagePoints) => {
                                if (roundedPoints < averagePoints - 1) {
                                    return 'rgb(220, 38, 38)';
                                } else if (roundedPoints >= averagePoints) {
                                    return 'rgb(77, 124, 15)';
                                } else {
                                    return '#eac714';
                                }
                            };

                            return (
                                <View key={id}>
                                    <View style={styles.tableContainer}>
                                        <View style={styles.tableFirstCol}>
                                            <View style={styles.tableFirstColAnswer}>
                                                <View style={styles.tableFirstColAnswerNumber}>
                                                    <Text
                                                        style={{
                                                            fontFamily: 'Inter',
                                                            fontSize: 10,
                                                            fontWeight: 600,
                                                            lineHeight: 1.1,
                                                        }}
                                                    >
                                                        F{(id >= 10 ? id + '.' : '0' + id + '.')}
                                                    </Text>
                                                </View>
                                                <View style={[styles.tableFirstColAnswerText, { height: 25, paddingBottom: 0 }]}>
                                                    <Text
                                                        style={{
                                                            fontFamily: 'Inter',
                                                            fontSize: 8,
                                                            lineHeight: 1.2,
                                                        }}
                                                    >
                                                        {(() => {
                                                            const fullText = answer;
                                                            const maxLength = 120;
                                                            return fullText.length > maxLength ? fullText.substring(0, maxLength) + '...' : fullText;
                                                        })()}
                                                    </Text>
                                                </View>
                                                <View style={styles.tableFirstColAnswerPoints}>
                                                    <Text
                                                        style={{
                                                            fontFamily: 'Inter',
                                                            fontSize: 10,
                                                            fontWeight: 700,
                                                        }}
                                                    >
                                                        {roundToTwoDecimals(points)}
                                                    </Text>
                                                </View>
                                            </View>
                                        </View>
                                        <View style={styles.tableLastCol}>
                                            <View style={styles.tableLastColRows}>
                                                <View
                                                    style={{
                                                        height: 10,
                                                        width: 10,
                                                        backgroundColor: getBackgroundColor(roundedPoints, averagePoints),
                                                        borderRadius: '50%',
                                                        position: 'absolute',
                                                        left: `${xPos - 0.5}%`,
                                                        top: 2,
                                                    }}
                                                ></View>
                                            </View>
                                        </View>
                                    </View>
                                </View>
                            );
                        }
                    )}
                    <View style={styles.scaleBarContainer}>
                        <View style={{ width: '60%' }}></View>
                        <View style={{ width: '40%', marginBottom: 10 }}>
                            <ScaleBarPulse />
                        </View>
                    </View>
                </View>

                {matchedCategory && (
                    <View style={styles.categoryText}>
                        {matchedCategory.description.map((item, index) => {
                            switch (item.type) {
                                case 'paragraph':
                                    return <Text
                                        key={index}
                                        style={{
                                            display: 'block',
                                            fontFamily: 'Inter',
                                            fontSize: 9,
                                            lineHeight: 1.4,
                                            marginBottom: 10,
                                        }}>{item.text}</Text>;
                                default:
                                    return null;
                            }
                        })}
                    </View>
                )}

            </View>
        </>
    )
}

export default AnswersTableGuideQuinary